import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

// Mirror of the API's InternalAuditControlAuditItemStatus (shared by the framework audit items).
export enum FrameworkAuditItemStatus {
  NotRun = 0,
  Waiting = 1,
  Running = 2,
  Ready = 3,
  Failed = 4,
  Skipped = 5,
}

export interface IFrameworkAuditItem {
  entityType: number;
  entityId: number;
  code?: string;
  name?: string;
  status: FrameworkAuditItemStatus;
  documentationStatus?: number;
  evidenceStatus?: number;
  error?: string;
}

export class TenantProcessStateFrameworkAudit {
  isoNormId: number;

  standardName: string;

  includeDocumentation: boolean;

  includeEvidence: boolean;

  sendCompletionEmail: boolean;

  items: IFrameworkAuditItem[];

  reportLinkId: number | undefined;

  reportLinkName: string;

  reportLinkUrl: string;

  conversation: CopilotConversation;

  constructor() {
    this.isoNormId = 0;
    this.standardName = '';
    this.includeDocumentation = true;
    this.includeEvidence = true;
    this.sendCompletionEmail = true;
    this.items = [];
    this.reportLinkId = undefined;
    this.reportLinkName = '';
    this.reportLinkUrl = '';
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateFrameworkAuditDTO {
  isoNormId: number;

  includeDocumentation: boolean;

  includeEvidence: boolean;

  sendCompletionEmail: boolean;

  conversation: CopilotConversationDTO;

  constructor() {
    this.isoNormId = 0;
    this.includeDocumentation = true;
    this.includeEvidence = true;
    this.sendCompletionEmail = true;
    this.conversation = new CopilotConversationDTO();
  }
}

// One framework audit that is running right now, for the "AI audit running" markers outside the panel.
export class ActiveFrameworkAudit {
  isoNormId: number;

  standardName: string;

  status: number;

  constructor() {
    this.isoNormId = 0;
    this.standardName = '';
    this.status = 0;
  }

  // Lets the shared store publish a new list only when something actually changed, so a quiet poll
  // does not re-render every scene and widget that shows the running marker.
  isEqual(other: ActiveFrameworkAudit): boolean {
    return (
      this.isoNormId === other.isoNormId && this.standardName === other.standardName && this.status === other.status
    );
  }
}

export class ActiveFrameworkAuditDTO {
  isoNormId: number;

  standardName: string;

  status: number;

  constructor() {
    this.isoNormId = 0;
    this.standardName = '';
    this.status = 0;
  }
}

// The standards scene has no single selected standard: the standard is picked in the panel via the
// selection card, and the definition stamps the choice here so entity-bound reads (persisted state,
// progress) know which process row to address.
export class CopilotFrameworkAuditContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.FrameworkAudit;

  isoNormId: number | undefined;

  constructor(isoNormId?: number) {
    super();
    this.isoNormId = isoNormId;
  }
}
